import { render, staticRenderFns } from "./UserDepartmentContainer.vue?vue&type=template&id=332e3992&scoped=true&"
import script from "./UserDepartmentContainer.vue?vue&type=script&lang=js&"
export * from "./UserDepartmentContainer.vue?vue&type=script&lang=js&"
import style0 from "./UserDepartmentContainer.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UserDepartmentContainer.vue?vue&type=style&index=1&id=332e3992&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332e3992",
  null
  
)

export default component.exports